/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { Component } from 'vue';
import { defineAsyncComponent } from 'vue';

type ComponentKey =
    | 'blogherocomponent'
    | 'blogoverview'
    | 'blogsections'
    | 'calltoactioncomponent'
    | 'categoriescomponent'
    | 'faqblock'
    | 'faqsections'
    | 'fourtysixtycomponent'
    | 'getstartedcomponent'
    | 'herocomponent'
    | 'imageitem'
    | 'interventionDetailComponent'
    | 'login'
    | 'relatedblogscomponent'
    | 'sixtyfourtycomponent'
    | 'stepscomponent'
    | 'teamcomponent'
    | 'testimonialscomponent'
    | 'textblock'
    | 'uspcomponent';

const componentMap: Record<ComponentKey, Component> = {
    blogherocomponent: async () => import('@/components/hero/BlogHero.vue'),
    blogoverview: async () => import('~/components/blogs/BlogsOverview.vue'),
    blogsections: async () => import('@/components/resource/Sections.vue'),
    calltoactioncomponent: async () => import('@/components/cta/CallToAction.vue'),
    categoriescomponent: async () => import('@/components/categories/CategoriesBlock.vue'),
    faqblock: async () => import('@/components/accordion/AccordionBlock.vue'),
    faqsections: async () => import('@/components/faq/FaqSections.vue'),
    fourtysixtycomponent: async () => import('@/components/rows/FourtySixty.vue'),
    getstartedcomponent: async () => import('@/components/rows/GetStarted.vue'),
    herocomponent: async () => import('@/components/hero/PageHero.vue'),
    imageitem: async () => import('@/components/imageitem/Image.vue'),
    login: async () => import('@/components/login/LoginComponent.vue'),
    relatedblogscomponent: async () => import('@/components/blogs/RelatedBlogs.vue'),
    sixtyfourtycomponent: async () => import('@/components/rows/SixtyFourty.vue'),
    stepscomponent: async () => import('@/components/steps/StepsBlock.vue'),
    testimonialscomponent: async () => import('@/components/testimonials/TestimonialBlock.vue'),
    textblock: async () => import('@/components/text/TextComponent.vue'),
    uspcomponent: async () => import('@/components/usp/UspBlock.vue'),
    interventionDetailComponent: async () => import('@/components/product/AboutApp.vue'),
    teamcomponent: async () => import('@/components/team/TeamBlock.vue'),
};

function isComponentKey(key: string): key is ComponentKey {
    return key in componentMap;
}

export const mapComponentAlias = (alias: string): Component | null => {
    const _alias = alias.toLocaleLowerCase();
    if (!isComponentKey(_alias)) return null;
    return defineAsyncComponent(componentMap[_alias] as () => Promise<Component>);
};
